import { render, staticRenderFns } from "./TemplateEventsErrorsPieChart.vue?vue&type=template&id=1035385e&scoped=true&"
import script from "./TemplateEventsErrorsPieChart.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsErrorsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsErrorsPieChart.vue?vue&type=style&index=0&id=1035385e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035385e",
  null
  
)

export default component.exports